import React, {useContext, useState} from 'react';
import {BoShowContext} from "../context/bo-show-context.jsx";
import ModalAttaches from "../../../../../components/modal/modal-attaches.jsx";

const BoShowInfos = () => {
    const {dataFetch, isSync} = useContext(BoShowContext);
    const boGcmItems = dataFetch?.bogcm;

    const [open, setOpen] = useState(false)

    if (!boGcmItems) return null;

    return (
        <>
            <hr className={"print:hidden opacity-25 text-[#676a6c]"}/>
            <div className={"mb-2 print:hidden space-y-1"}>
                {
                    boGcmItems?.numberGenerateDate &&
                    <h3 className={"!font-normal"}>
                        Numeração gerada por <strong>{boGcmItems.numberGenerateUserName}</strong> em <strong>{boGcmItems.numberGenerateDate}</strong>
                    </h3>
                }

                {
                    boGcmItems?.lastEditDate && !isSync &&
                    <h3 className={"!font-normal"}>
                        Editado por <strong>{boGcmItems.lastEditUserName}</strong> em <strong>{boGcmItems.lastEditDate}</strong>
                    </h3>
                }
                
                {
                    boGcmItems?.lastApprovalDate && !isSync &&
                    <h3 className={"!font-normal"}>
                        Aprovado por último por <strong>{boGcmItems.lastApprovalUserName}</strong> em <strong>{boGcmItems.lastApprovalDate}</strong>
                        {
                            boGcmItems.lastApprovalSignature &&
                            <span className={"ms-1 cursor-pointer"} onClick={() => setOpen(true)}>(ver assinatura)</span>
                        }
                    </h3>
                }
                
                {
                    boGcmItems?.invalidatedDate &&
                    <>
                        <hr className={"opacity-25 text-[#676a6c]"}/>
                        <h3 className={"!font-normal"}>
                            Invalidado por <strong>{boGcmItems.invalidatedUserName}</strong> em <strong>{boGcmItems.invalidatedDate}</strong>
                        </h3>
                        <h3 className={"!font-normal"}>
                            {boGcmItems.invalidatedObservation}
                        </h3>
                    </>
                }
            </div>

            {
                boGcmItems.lastApprovalSignature &&
                <ModalAttaches
                    file={{attachId: boGcmItems.lastApprovalSignature, extension: boGcmItems.lastApprovalSignatureExtension}}
                    open={open}
                    setOpen={setOpen}
                />
            }
        </>
    );
};

export default BoShowInfos;